import { styled } from 'styled-components';

const ButtonGroup = ({ label, options, active, handleChange }) => {
  return (
    <GroupWrapper>
      {options.map((option, ind) => (
        <Button
          key={`group-button-${ind}`}
          type='button'
          onClick={() => handleChange(option)}
          $active={active === option}
        >
          {option}
        </Button>
      ))}
    </GroupWrapper>
  );
};

const GroupWrapper = styled.div`
  display: flex;
  gap: ${props => props.theme.spaceMd};
  background-color: ${props => props.theme.backgroundColor};
  border: 2px solid ${props => props.theme.backgroundColor};
  border-radius: ${props => props.theme.borderFull};
`;

const Button = styled.button`
  width: 100%;
  padding: ${props => props.theme.paddingMd};
  font-size: ${props => props.theme.sizeSmall};
  border: none;

  ${props =>
    props.$active
      ? `
        color: ${props.theme.backgroundColor};
        background-color: ${props.theme.brand};

        &:active {
          scale: 0.98;
          box-shadow: 0 0 0 4px ${props.theme.backgroundColor},
            0 0 0 6px ${props.theme.brand + props.theme.clear50};
        }
      `
      : `
        color: ${props.theme.mutedColor};
        background-color: transparent;

        &:hover {
          color: ${props.theme.textColor};
        }
      `}
`;

export default ButtonGroup;
